import { MapTo } from "@adobe/aem-react-editable-components";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
import { PushBlock } from "./PushBlock";
export const pushBlockEditConfig = {
    emptyLabel: "PushBlock",
    isEmpty: (props) => !props.imgDesktop || !props.title || !props.cta || !props.text || !props.href || !props.orientation,
    getProps: (props) => ({
        title: props.title,
        text: props.text,
        orientation: props.orientation,
        imgMobile: props.imgMobile,
        imgDesktop: props.imgDesktop,
        alt: props.alt,
        cta: props.cta,
        href: props.href,
        ctaLogged: props.ctaLogged,
        hrefLogged: props.hrefLogged,
        ctaRestricted: props.ctaRestricted,
        hrefRestricted: props.hrefRestricted,
    }),
};
export default MapTo("loyalty/components/pushblock")(withAemAuthoring(PushBlock, pushBlockEditConfig));
